module.exports = __webpack_public_path__ + "media/images/home/motivacao_bg-e18f5685b187c01bce77fb0cb1cdbb24.jpg";